<div class="flex flex-row justify-center">
    <ng-container *ngTemplateOutlet="data.templateRef;context:data"></ng-container>
</div>
